import { render, staticRenderFns } from "./registerList.vue?vue&type=template&id=019e3bbe&scoped=true&"
import script from "./registerList.vue?vue&type=script&lang=js&"
export * from "./registerList.vue?vue&type=script&lang=js&"
import style0 from "./registerList.vue?vue&type=style&index=0&id=019e3bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e3bbe",
  null
  
)

export default component.exports